import Headings from "../../src/utils/csvHeadings.utils";
import { CommonCsvFunctions } from "./commonCsvFunctions.mixin";
import { mapState, mapActions } from "vuex";
const itemTypeValues = [
	"sku",
	"raw material",
	"serveware",
	"consumable",
	"condiments",
	"cleaning",
	"kitchen equipment",
	"miscellaneous",
	"menu item"
];
const productItemType = ["sku", "raw material", "menu item"];
const stockComesFromOptions = ["prepared", "internal", "vendor"];
export const ArticleMaster = {
	mixins: [CommonCsvFunctions],
	data() {
		return {
			// nullArray: []
		};
	},
	computed: {
		...mapState("UploadCsvStore", [
			"articleCodeUniqueValueCheck",
			"CategoryCheckInAM",
			"SubCategoryCheckInAM"
		])
	},
	methods: {
		...mapActions("UploadCsvStore", [
			"updateArticleCodeUniqueValueCheck",
			"UpdateCategoryCheckInAM",
			"UpdateSubCategoryCheckInAM"
		]),

		processArticleMaster(chunk) {
			// debugger;
			// console.log("chunk", chunk);
			// console.log("error arra length", chunk.errors.length);
			// var result = {};
			if (!chunk.errors.length) {
				const headings = chunk.meta.fields;
				const status = this.checkHeadingsEquality(
					Headings.articleMaster,
					headings
				);
				// console.log("status in am", status);
				if (!status) {
					// console.log(Headings.articleMaster, headings);
					this.addError({
						row: 1,
						column: "",
						details: `Headings should be as following: ${
							Headings.articleMaster
						}`
					});
					// this.$notify.error({
					// 	title: "Fail",
					// 	dangerouslyUseHTMLString: true,
					// 	message: `<p>The Headings should be as following.</p><ul>${Headings.articleMaster
					// 		.map(item => `<li>${item}</li>`)
					// 		.join("")}</ul>`,
					// 	duration: 0
					// });
					// return false; // validation not complete
				}
				if (status) {
					// console.log("inside status true");
					// result.headings = Headings.articleMaster.map(heading => {
					// 	return {
					// 		value: heading,
					// 		isError: false,
					// 		colspan: 1
					// 	};
					// });
					const data = chunk.data;
					// console.log("data", data);

					data.map((row, rowIndex) => {
						// console.log("row in map", row);
						// console.log("row", row);
						this.getModifiedAmRow(row, rowIndex);
					});
					if (this.CategoryCheckInAM.full && this.CategoryCheckInAM.empty) {
						this.addError({
							row: "",
							column: "Category",
							details:
								"values in this column can either be all filled or all empty"
						});
					}
					if (
						this.SubCategoryCheckInAM.full &&
						this.SubCategoryCheckInAM.empty
					) {
						this.addError({
							row: "",
							column: "Sub Category",
							details:
								"values in this column can either be all filled or all empty"
						});
					}
					// console.log("resultin article master csv", result);
				}

				// add empty category or empty sub category errors
				// const nullErrors = this.getNullErrors(result);
				// // console.log("nullErrors", nullErrors);
				// nullErrors.forEach(obj => {
				// 	// console.log("obj in nullErros", obj);
				// 	obj.isError = true;
				// 	obj.details.push(
				// 		"values in this column can either be all filled or all empty"
				// 	);
				// });

				// add edit and delete properties to each row
				// result.rows.forEach(row => {
				// 	// console.log(row);
				// 	const editObjOfRow = this.getParticularObject(
				// 		row,
				// 		"el-icon-edit",
				// 		"Edit"
				// 	);
				// 	editObjOfRow.type = "button";
				// 	editObjOfRow.file = "articleMaster";
				// 	const deleteObjOfRow = this.getParticularObject(
				// 		row,
				// 		"el-icon-delete",
				// 		"Delete"
				// 	);
				// 	deleteObjOfRow.type = "button";
				// 	deleteObjOfRow.file = "articleMaster";

				// 	row["Edit"] = editObjOfRow;
				// 	row["Delete"] = deleteObjOfRow;
				// });
				// result.headings = [
				// 	{ value: "Edit", isError: false, details: [] },
				// 	{ value: "Delete", isError: false, details: [] }
				// ].concat(result.headings);
				// console.log("result ...", result);
			}
			// return result;
			// return true; // validation complete
		},
		// getNullErrors(errorsArray) {
		// 	// console.log("errorArray", errorsArray);
		// 	var result = [];

		// 	errorsArray.rows.forEach(rowObj => {
		// 		const categoryPredicate = this.validateNullErrorForCategory(
		// 			rowObj.Category.value
		// 		);
		// 		if (categoryPredicate) result.push(rowObj.Category);

		// 		const subCategoryPredicate = this.validateNullErrorForSubCategory(
		// 			rowObj["Sub Category"].value
		// 		);
		// 		if (subCategoryPredicate) result.push(rowObj["Sub Category"]);
		// 	});
		// 	// console.log("result in getNullErrors", result);
		// 	return result;
		// },

		getModifiedAmRow(row, rowIndex) {
			// console.log("row in getmodifiedrow", row);
			// const modifiedRow = {};
			/*A 	Item Code */
			if (row.hasOwnProperty("Item Code") && row["Item Code"]) {
				// const particularRowObject = this.getParticularObject(
				// 	modifiedRow,
				// 	row["Item Code"],
				// 	"Item Code"
				// );
				// console.log("check if Item Code key exists");
				this.validateAmItemCode(row["Item Code"], rowIndex);
			}

			if (row.hasOwnProperty("Item Description")) {
				// const particularRowObject = this.getParticularObject(
				// 	modifiedRow,
				// 	row["Item Description"],
				// 	"Item Description"
				// );
				this.validateAmItemDescription(row["Item Description"], rowIndex);
			}

			if (
				row.hasOwnProperty("Item Type") &&
				row.hasOwnProperty("Forecast Type") &&
				row.hasOwnProperty("Stock Comes from")
			) {
				// const particularRowObject = this.getParticularObject(
				// 	modifiedRow,
				// 	row["Item Type"],
				// 	"Item Type"
				// );
				this.validateAmItemType(
					row["Item Type"],
					row["Forecast Type"],
					row["Stock Comes from"],
					rowIndex
				);
			}

			if (row.hasOwnProperty("Department")) {
				// const particularRowObject = this.getParticularObject(
				// 	modifiedRow,
				// 	row["Department"],
				// 	"Department"
				// );
				this.validateAmDepartment(row["Department"], rowIndex);
			}

			if (row.hasOwnProperty("Category")) {
				// const particularRowObject = this.getParticularObject(
				// 	modifiedRow,
				// 	row["Category"],
				// 	"Category"
				// );
				this.validateAmCategory(row["Category"], rowIndex);
			}

			if (row.hasOwnProperty("Sub Category")) {
				this.validateAmSubCategory(row["Sub Category"], rowIndex);
			}

			if (row.hasOwnProperty("Service Level")) {
				this.validateAmServiceLevel(row["Service Level"], rowIndex);
			}

			if (row.hasOwnProperty("Sales Price")) {
				this.validateAmSalesPrice(
					row["Sales Price"],
					row["Item Type"],
					rowIndex
				);
			}

			if (
				row.hasOwnProperty("Order Unit") &&
				row.hasOwnProperty("Stock Comes from") &&
				row.hasOwnProperty("Contains Each(Base)")
			) {
				this.validateAmOrderUnit(
					row["Order Unit"],
					row["Stock Comes from"],
					row["Contains Each(Base)"],
					rowIndex
				);
			}

			if ("Contains Each(Base)" in row && "Stock Comes from" in row) {
				this.validateAmContainsEachBase(row["Contains Each(Base)"], rowIndex);
			}

			if ("Base Unit" in row) {
				this.validateAmBaseUnit(row["Base Unit"], rowIndex);
			}

			if ("Primary Shelf life" in row && "Stock Comes from" in row) {
				this.validateAmShelfLifeType(
					row["Primary Shelf life"],
					row["Stock Comes from"],
					rowIndex,
					"Primary Shelf life"
				);
			}
			if ("Secondary Shelf life" in row && "Stock Comes from" in row) {
				this.validateAmShelfLifeType(
					row["Secondary Shelf life"],
					row["Stock Comes from"],
					rowIndex,
					"Secondary Shelf life"
				);
			}

			if ("Ordering Frequency" in row && "Stock Comes from" in row) {
				this.validateAmOrderingFrequency(
					row["Ordering Frequency"],
					row["Stock Comes from"],
					rowIndex
				);
			}

			if ("Forecast Type" in row && "Stock Comes from" in row) {
				this.validateAmForecastType(
					row["Forecast Type"],
					row["Stock Comes from"],
					rowIndex
				);
			}

			if ("Lead Time" in row && "Stock Comes from" in row) {
				this.validateAmLeadTime(
					row["Lead Time"],
					row["Stock Comes from"],
					rowIndex,
					"Lead Time"
				);
			}

			if ("Current Cost" in row && "Stock Comes from" in row) {
				this.validateAmCurrentCost(
					row["Current Cost"],
					row["Stock Comes from"],
					rowIndex
				);
			}

			// if ("Product Remarks" in row) {
			// 	this.validateAmProductRemarks(row["Product Remarks"], rowIndex);
			// }

			if ("Stock Comes from" in row && "Forecast Type" in row) {
				this.validateAmStockComesFrom(row["Stock Comes from"], rowIndex);
			}
			if ("Min Stock Level" in row) {
				this.validateAmMinStockLevel(
					row["Min Stock Level"],
					row["Forecast Type"],
					rowIndex
				);
			}
		},
		validateAmStockComesFrom(stockComesFrom, rowIndex) {
			stockComesFrom =
				stockComesFrom !== null
					? stockComesFrom.toString().toLowerCase()
					: null;
			// if (stockComesFrom !== null && !this.checkForString(stockComesFrom)) {
			// 	this.addError({
			// 		row: rowIndex + 2,
			// 		column: "Stock Comes from",
			// 		details: "value should be a string"
			// 	});
			// }

			if (stockComesFrom === null) {
				this.addError({
					row: rowIndex + 2,
					column: "Stock Comes from",
					details: "value can't be empty"
				});
			}

			if (
				stockComesFrom !== null &&
				!stockComesFromOptions.some(val => stockComesFrom === val)
			) {
				this.addError({
					row: rowIndex + 2,
					column: "Stock Comes from",
					details: `value should be one among ${stockComesFromOptions}`
				});
			}
		},
		// validateAmProductRemarks(productRemarks, rowIndex) {
		// 	if (productRemarks) {
		// 		if (!this.checkForString(productRemarks)) {
		// 			this.addError({
		// 				row: rowIndex + 2,
		// 				column: "Product Remarks",
		// 				details: "value should be a string"
		// 			});
		// 		}
		// 	}
		// },
		validateAmMinStockLevel(minStockLevel, forecastType, rowIndex) {
			if (minStockLevel !== null) {
				if (!this.checkForNumber(minStockLevel) || minStockLevel < 0) {
					this.addError({
						row: rowIndex + 2,
						column: "Min Stock Level",
						details: "value should be an integer greater than -1"
					});
				}

				if (
					this.checkForNumber(minStockLevel) &&
					this.checkIfDecimalNumber(minStockLevel)
				) {
					this.addError({
						row: rowIndex + 2,
						column: "Min Stock Level",
						details: "value can't be a decimal number"
					});
				}
			}
			if (forecastType === "manual" && minStockLevel === null) {
				this.addError({
					row: rowIndex + 2,
					column: "Min Stock Level",
					details: "value can't be empty if forecast type is 'manual'"
				});
			}
		},
		validateAmCurrentCost(currentCost, stockComesFrom, rowIndex) {
			if (stockComesFrom === "internal" && currentCost === null) {
				this.addError({
					row: rowIndex + 2,
					column: "Current Cost",
					details: "value can't be empty if stock comes from is 'internal'"
				});
			}

			if (
				currentCost !== null &&
				(!this.checkForNumber(currentCost) || currentCost < 0)
			) {
				this.addError({
					row: rowIndex + 2,
					column: "Current Cost",
					details: "value should be an integer greater than -1"
				});
			}
		},
		validateAmForecastType(forecastType, stockComesFrom, rowIndex) {
			forecastType =
				forecastType !== null ? forecastType.toString().toLowerCase() : null;
			if (
				forecastType &&
				!["forecast", "manual"].some(val => forecastType === val)
			) {
				this.addError({
					row: rowIndex + 2,
					column: "Forecast Type",
					details: "value can either be forecast or manual"
				});
			}

			if (stockComesFrom === "prepared" && forecastType === "manual") {
				this.addError({
					row: rowIndex + 2,
					column: "Forecast Type",
					details: "value can't be manual if stock comes from is prepared"
				});
			}
			if (forecastType === null) {
				this.addError({
					row: rowIndex + 2,
					column: "Forecast Type",
					details: "value can't be empty"
				});
			}
		},
		validateAmOrderingFrequency(value, stockComesFrom, rowIndex) {
			if (stockComesFrom !== "prepared" && value === null) {
				this.addError({
					row: rowIndex + 2,
					column: "Ordering Frequency",
					details: "value can't be empty if stock comes from is not prepared"
				});
			}

			if (value !== null && (!this.checkForNumber(value) || value < 0)) {
				this.addError({
					row: rowIndex + 2,
					column: "Ordering Frequency",
					details: "value should be an integer greater than -1"
				});
			}
		},

		validateAmShelfLifeType(value, stockComesFrom, rowIndex, columnName) {
			if (stockComesFrom !== "prepared" && value === null) {
				this.addError({
					row: rowIndex + 2,
					column: columnName,
					details: "value can't be empty when stock comes from is not prepared"
				});
			}

			if (value !== null && (!this.checkForNumber(value) || value < 1)) {
				this.addError({
					row: rowIndex + 2,
					column: columnName,
					details: "value should be a Integer greater than 0"
				});
			}
		},

		validateAmLeadTime(value, stockComesFrom, rowIndex, columnName) {
			if (stockComesFrom !== "prepared" && value === null) {
				this.addError({
					row: rowIndex + 2,
					column: columnName,
					details: "value can't be empty if stock comes from is not prepared"
				});
			}

			if (value !== null && (!this.checkForNumber(value) || value < 0)) {
				this.addError({
					row: rowIndex + 2,
					column: columnName,
					details: "value should be a Integer greater than 0"
				});
			}

			if (this.checkForNumber(value) && this.checkIfDecimalNumber(value)) {
				this.addError({
					row: rowIndex + 2,
					column: columnName,
					details: "value should'nt be a decimal number"
				});
			}
		},
		validateAmBaseUnit(baseUnit, rowIndex) {
			if (baseUnit === null) {
				this.addError({
					row: rowIndex + 2,
					column: "Base Unit",
					details: "value can't be empty"
				});
			}

			if (baseUnit !== null && !this.checkForString(baseUnit)) {
				this.addError({
					row: rowIndex + 2,
					column: "Base Unit",
					details: "value should be a string"
				});
			}
		},
		validateAmContainsEachBase(containsEachBase, rowIndex) {
			if (containsEachBase !== null) {
				if (!this.checkForNumber(containsEachBase)) {
					this.addError({
						row: rowIndex + 2,
						column: "Contains Each(Base)",
						details: "value should be a Integer"
					});
				}
				if (containsEachBase < 0) {
					this.addError({
						row: rowIndex + 2,
						column: "Contains Each(Base)",
						details: "value should be a Integer greater than -1"
					});
				}
			}
		},
		validateAmOrderUnit(orderUnit, stockComesFrom, containsEachBase, rowIndex) {
			if (orderUnit !== null && !this.checkForString(orderUnit)) {
				this.addError({
					row: rowIndex + 2,
					column: "Order Unit",
					details: "value should be string"
				});
			}

			if (stockComesFrom === "internal" && orderUnit === null) {
				this.addError({
					row: rowIndex + 2,
					column: "Order Unit",
					details: "value can't be empty when stock comes from is internal"
				});
			}

			if (
				(orderUnit && containsEachBase === null) ||
				(orderUnit === null && containsEachBase)
			) {
				this.addError({
					row: rowIndex + 2,
					column: "Order Unit",
					details:
						"order unit and contains each base can either be empty or filled as a pair"
				});
			}
		},
		validateAmItemCode(itemCode, rowIndex) {
			// console.log("inside validateAmItemCode");
			// particularRowObject.isError = false;
			const uniqueArticleCodeValue = String(itemCode).hashCode();
			// console.log("uniqueArticleCodeValue", uniqueArticleCodeValue);

			if (itemCode) {
				if (!this.checkForAlphaNumeric(itemCode)) {
					this.addError({
						row: rowIndex + 2,
						column: "Item Code",
						details: "value not alpha numeric"
					});
					// this.pushError(particularRowObject, "value not alpha numeric");
				}
				if (
					!this.articleCodeUniqueValueCheck.hasOwnProperty(
						uniqueArticleCodeValue
					)
				) {
					this.updateArticleCodeUniqueValueCheck(uniqueArticleCodeValue); // action in store
				} else {
					this.addError({
						row: rowIndex + 2,
						column: "Item Code",
						details: "value not unique"
					});
					// this.pushError(particularRowObject, `value not unique`);
				}
			}
			// if (!particularRowObject.isError) particularRowObject.details = [];
		},
		validateAmItemDescription(itemDescription, rowIndex) {
			// particularRowObject.isError = false;
			if (itemDescription) {
				if (!this.checkForString(itemDescription)) {
					this.addError({
						row: rowIndex + 2,
						column: "Item Description",
						details: "value must be string"
					});
					// this.pushError(particularRowObject, `value not string`);
				}
			}
			if (itemDescription === null) {
				this.addError({
					row: rowIndex + 2,
					column: "Item Description",
					details: "value can't be empty"
				});
			}
		},
		validateAmItemType(itemType, forecastType, stockComesFrom, rowIndex) {
			// console.log("inside validate item type");
			// particularRowObject.isError = false;
			var itemType =
				itemType !== null ? itemType.toString().toLowerCase() : null;
			// console.log("itemType", itemType);
			if (itemType) {
				if (!itemTypeValues.some(val => itemType === val)) {
					this.addError({
						row: rowIndex + 2,
						column: "Item Type",
						details: `value should be one of ${itemTypeValues}`
					});
				}
			}

			if (
				forecastType === "manual" &&
				productItemType.some(val => itemType === val)
			) {
				this.addError({
					row: rowIndex + 2,
					column: "Item Type",
					details: `value should'nt be one of ${productItemType} if forecast type is 'manual'`
				});
			}
			// console.log(
			// 	"producttype",
			// 	!productItemType.some(val => itemType === val)
			// );
			if (
				stockComesFrom === "prepared" &&
				!productItemType.some(val => itemType === val)
			) {
				this.addError({
					row: rowIndex + 2,
					column: "Item Type",
					details: `value should be one of ${productItemType} if stock comes from is 'prepared'`
				});
			}

			if (itemType === null) {
				this.addError({
					row: rowIndex + 2,
					column: "Item Type",
					details: "value can't be empty"
				});
			}
		},
		validateAmDepartment(department, rowIndex) {
			// particularRowObject.isError = false;
			if (department) {
				if (!this.checkForString(department)) {
					this.addError({
						row: rowIndex + 2,
						column: "Department",
						details: "value should be a string"
					});
					// this.pushError(particularRowObject, "value should be a string");
				}
			}
			if (department === null) {
				this.addError({
					row: rowIndex + 2,
					column: "Department",
					details: "value can't be empty"
				});
				// this.pushError(particularRowObject, "value can't be empty");
			}
			// if (!particularRowObject.isError) particularRowObject.details = [];
		},
		validateAmCategory(category, rowIndex) {
			category !== null // category column should be either all full or all empty.
				? this.UpdateCategoryCheckInAM("full")
				: this.UpdateCategoryCheckInAM("empty");

			if (category) {
				if (!this.checkForString(category)) {
					this.addError({
						row: rowIndex + 2,
						column: "Category",
						details: "value should be a string"
					});
					// this.pushError(particularRowObject, "value should be a string");
				}
			}
			// if (!particularRowObject.isError) particularRowObject.details = [];
		},
		validateAmSubCategory(subCategory, rowIndex) {
			subCategory // subcategory column should be either all full or all empty.
				? this.UpdateSubCategoryCheckInAM("full")
				: this.UpdateSubCategoryCheckInAM("empty");

			if (subCategory) {
				if (!this.checkForString(subCategory)) {
					this.addError({
						row: rowIndex + 2,
						column: "Sub Category",
						details: "value should be a string"
					});
					// this.pushError(particularRowObject, "value should be a string");
				}
			}
			// if (!particularRowObject.isError) particularRowObject.details = [];
		},
		// validateAmServiceLevel(serviceLevel, rowIndex) {
		// 	if (
		// 		serviceLevel ||
		// 		!checkForNumber(serviceLevel) ||
		// 		!(0 <= serviceLevel <= 100)
		// 	) {
		// 		this.addError({
		// 			row: rowIndex + 2,
		// 			column: "Service Level",
		// 			details: "value should be a number between 0 and 100"
		// 		});
		// 	}
		// 	if (!serviceLevel) {
		// 		this.addError({
		// 			row: rowIndex + 2,
		// 			column: "Service Level",
		// 			details: "value should be a number between 0 and 100"
		// 		});
		// 		// this.pushError(particularRowObject, "value should be a integer or n/a");
		// 	}
		// 	// if (!particularRowObject.isError) particularRowObject.details = [];
		// },
		// this.checkIfDecimalNumber(serviceLevel)
		validateAmServiceLevel(serviceLevel, rowIndex) {
			if (serviceLevel !== null) {
				if (
					!this.checkForNumber(serviceLevel) ||
					serviceLevel < 0 ||
					serviceLevel > 100
				) {
					this.addError({
						row: rowIndex + 2,
						column: "Service Level",
						details: "value should be between 0 and 100"
					});
				}
			}
		},
		validateAmSalesPrice(salesPrice, itemType, rowIndex) {
			itemType = itemType !== null ? itemType.toString().toLowerCase() : null;

			if (
				salesPrice !== null &&
				(!this.checkForNumber(salesPrice) || salesPrice < 0)
			) {
				this.addError({
					row: rowIndex + 2,
					column: "Sales Price",
					details: "value should be an integer greater than -1"
				});
			}

			if (["sku"].some(val => itemType === val) && salesPrice === null) {
				this.addError({
					row: rowIndex + 2,
					column: "Sales Price",
					details: "value should'nt be empty for item type 'sku'"
				});
			}
		}
	}
};
